// Copy button for stack-trace <pre> blocks (marked with data-copy). Plain JS on purpose: it is
// served as-is to the JSP error page (which loads no bundle) and imported into main.js for the
// AJAX error dialog, so both share this one implementation. Dependency-free (no jQuery, no i18n).

export function enhanceCopyable(pre, label) {
	if (!navigator.clipboard) {
		// clipboard is only available in a secure context
		return;
	}
	const wrapper = document.createElement("div");
	wrapper.className = "copyable-stack-trace";
	pre.parentNode.insertBefore(wrapper, pre);
	wrapper.appendChild(pre);

	const icon = document.createElement("i");
	icon.className = "icon-copy3 text-primary";
	const button = document.createElement("button");
	button.type = "button";
	button.className = "btn btn-default btn-xs";
	button.title = label;
	button.setAttribute("aria-label", label);
	button.appendChild(icon);
	wrapper.appendChild(button);

	button.addEventListener("click", () => {
		void navigator.clipboard.writeText(pre.textContent ?? "");
		icon.className = "icon-checkmark text-success";
		setTimeout(() => {
			icon.className = "icon-copy3 text-primary";
		}, 1500);
	});
}

function initCopyable() {
	document.querySelectorAll("pre[data-copy]").forEach((pre) => {
		enhanceCopyable(pre, pre.dataset.copyLabel ?? "");
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initCopyable);
} else {
	initCopyable();
}
